import { fetch_sadap } from "../../../../core/api"

export const upload_file = (file) => {
    return fetch_sadap("report/upload-file", "post", file, true)
}